export const parseBoolean = (val: unknown) => {
  return `${val}` === 'true';
};
